import { render, staticRenderFns } from "./EmailOutboxTable.vue?vue&type=template&id=f2499e24"
import script from "./EmailOutboxTable.vue?vue&type=script&lang=js"
export * from "./EmailOutboxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports